export interface MenuItem {
  pageId: string
  pageName: string
  pageSlug: string
  parentPageId: string | null
  /** 동적 라우트 매칭용 접두사 (예: /products/) */
  slugPattern?: string
  pageRole?: string[]
  /** 메뉴/네비게이션에 노출 여부 */
  showMenu?: boolean
}

/** 랜딩 사이트 메뉴 목록 (routing_role.json과 동기화) */
export const adminMenuList: MenuItem[] = [
  {
    pageId: 'e530bf91-da75-4f8a-b991-1fc989397c40',
    pageName: '서비스 소개',
    pageSlug: '/',
    parentPageId: null,
    showMenu: true,
  },
  {
    pageId: 'a1b2c3d4-5e6f-4a5b-8c9d-0e1f2a3b4c5d',
    pageName: '사업 소개',
    pageSlug: '/about',
    parentPageId: null,
    showMenu: true,
  },
  {
    pageId: 'b2c3d4e5-6f7a-4b5c-9d0e-1f2a3b4c5d6e',
    pageName: '상품 리스트',
    pageSlug: '/products',
    parentPageId: null,
    showMenu: true,
  },
  {
    pageId: 'c3d4e5f6-a7b8-4c5d-0e1f-2a3b4c5d6e7f',
    pageName: '상품 상세',
    pageSlug: '/products/detail',
    slugPattern: '/products/',
    parentPageId: 'b2c3d4e5-6f7a-4b5c-9d0e-1f2a3b4c5d6e',
    showMenu: false,
  },
  {
    pageId: '045a974b-127c-438e-9f21-ba13c172f304',
    pageName: '고객 문의',
    pageSlug: '/contact',
    parentPageId: null,
    showMenu: true,
  },
  {
    pageId: 'b2c61aba-408d-43a7-b03e-782d51f2d43b',
    pageName: '문의하기(성공)',
    pageSlug: '/contact/success',
    parentPageId: '045a974b-127c-438e-9f21-ba13c172f304',
    showMenu: false,
  },
  {
    pageId: '51575200-6ce1-4412-ac24-a057e4563408',
    pageName: '404페이지',
    pageSlug: '/error/pageNotFound',
    parentPageId: null,
    showMenu: false,
  },
  {
    pageId: 'fd9e9b02-df31-46d4-8264-0478384b003a',
    pageName: '403 페이지',
    pageSlug: '/error/permission',
    parentPageId: null,
    showMenu: false,
  },
]
